// Minimal translation dictionary for FR/EN
export const translations = {
  fr: {

    // navbar
    'nav.home': 'Accueil',
    'nav.features': 'Services',
    'nav.pricing': 'Tarifs',
    'nav.contact': 'Contact',
    'nav.demo': 'Démo',
    'nav.asavoir': "A savoir",
    'nav.login': 'Connexion',
    'nav.logout': 'Déconnexion',
    'nav.lang': 'Fr',
    'nav.history': 'Historique',
    'nav.dashboard': 'Tableau de bord',
    'nav.lang.fr': 'Français',
    'nav.lang.en': 'English',
    'nav.documentation': 'Documentation',


    // MultiStepForm
    'msf.langue': 'Français',
    'msf.title': "Formulaire d'analyse",
    'msf.loading': 'Veuillez patienter',
    'msf.loading.detailed': 'Analyse en cours... cela peut prendre jusqu\'à 1-2 minutes selon la taille du FEC.',
    'msf.loading.stepUpload': 'Envoi sécurisé des fichiers',
    'msf.loading.stepCheck': 'Contrôle de conformité',
    'msf.loading.stepAnalysis': 'Analyse et traitements',
    'msf.loading.stepReport': 'Génération des résultats',
    'msf.draft.resumePrompt': 'Reprendre le dernier brouillon enregistré ?',
    'msf.steps.import': "Importation, informations générales et vérification de la conformité",
    'msf.section.importGeneral': 'Import & Informations générales',
    'msf.section.compliance': 'Conformité',
    'msf.btn.loadFec': 'Charger un fichier FEC',
    'msf.btn.loadJournals': 'Charger des journaux',
    'msf.btn.importPrevFec': 'FEC de l’année précédente',
    'msf.btn.clearSelection': 'Vider la sélection',
    'msf.hint.selectOneFile': 'Sélectionnez exactement un fichier',
    'msf.hint.selectPrevFec': 'Fec de l’année N-1 (optionnel, mais recommandé pour les analyses comparatives)',
    'msf.hint.upTo10Files': 'Jusqu’à 10 fichiers',
    'msf.hint.csvxlsx': '(CSV/XLSX acceptés)',
    'msf.label.chart': 'Plan comptable utilisé',
    'msf.option.select': '-- Sélectionner --',
    'msf.label.openDate': "Date d'ouverture de l'exercice",
    'msf.label.closeDate': "Date de clôture de l'exercice",
    'msf.placeholder.date': 'jj/mm/aaaa',
    'msf.c.label.journal_code': 'Code journal',
    'msf.c.label.journal_label': 'Libellé journal',
    'msf.c.label.entry_number': "Numéro d'écriture comptable",
    'msf.c.label.entry_date': "Date d'écriture comptable",
    'msf.c.label.account_number': 'Numéro de compte',
    'msf.c.label.account_label': 'Libellé de compte',
    'msf.c.label.entry_label': "Libellé d'écriture",
    'msf.c.label.document_ref': 'Référence de la pièce comptable',
    'msf.c.label.currency': 'Devise de la pièce comptable',
    'msf.c.label.document_date': 'Date de la pièce comptable',
    'msf.c.label.debit_amount': 'Montant débit',
    'msf.c.label.credit_amount': 'Montant crédit',
    'msf.c.label.validation_date': "Date de validation de l'écriture",
    'msf.c.placeholder.journal_code': 'journal_code',
    'msf.c.placeholder.journal_label': 'journal_label',
    'msf.c.placeholder.entry_number': 'entry_number',
    'msf.c.placeholder.entry_date': 'entry_date',
    'msf.c.placeholder.account_number': 'account_number',
    'msf.c.placeholder.account_label': 'account_label',
    'msf.c.placeholder.entry_label': 'entry_label',
    'msf.c.placeholder.document_ref': 'document_ref',
    'msf.c.placeholder.currency': 'currency',
    'msf.c.placeholder.document_date': 'document_date',
    'msf.c.placeholder.debit_amount': 'debit_amount',
    'msf.c.placeholder.credit_amount': 'credit_amount',
    'msf.c.placeholder.validation_date': 'validation_date',
    'msf.err.chooseImportMode': "Veuillez choisir une option d'importation.",
    'msf.err.selectExactlyOneFec': 'Sélectionnez exactement un (1) fichier FEC.',
    'msf.err.prevFecRequired': "Si vous cochez l'option, ajoutez le FEC de l'année précédente.",
    'msf.err.atLeastOneFile': 'Au moins un fichier est obligatoire.',
    'msf.err.maxFiles': 'Maximum 10 fichiers autorisés.',
    'msf.err.required': 'Champ requis',
    'msf.err.closeAfterOpen': "La date de clôture doit être postérieure à la date d’ouverture.",
    'msf.err.intervalOneYear': "L’intervalle entre l’ouverture et la clôture doit être d’un an (365 à 366 jours).",
    'msf.err.tooManyKeepFirst10': 'Vous avez sélectionné plus de 10 fichiers. Seuls les 10 premiers ont été conservés.',
    'msf.err.prevFecN1': 'Veuillez sélectionner le FEC N-1.',
    'msf.err.prefix': 'Erreur :',
    'msf.btn.submit': 'Soumettre',
    'msf.btn.cancel': 'Annuler',


    // Payment
    'payment.title': 'Paiement',
    'payment.selectedPlan': 'Forfait sélectionné',
    'payment.connectedAs': 'Connecté en tant que',
    'payment.back': 'Retour',

    'payment.offer1.badge': 'Offre 1',
    'payment.offer1.title': 'Analyse simple sans synthèse IA',
    'payment.offer1.desc': 'Une analyse simple fournie telle quelle, sans synthèse IA. Idéal pour un audit rapide.',

    'payment.offer2.badge': 'Offre 2',
    'payment.offer2.title': 'Analyse avec une synthèse du rapport par IA',
    'payment.offer2.desc': "Analyse complète accompagnée d'une synthèse générée par IA : points clés, recommandations et résumé actionnable.",

    'payment.offer3.badge': 'Offre 3',
    'payment.offer3.title': 'Personnalisable Analyses simples',
    'payment.offer3.desc': "Choisissez le nombre d'analyses. Le total dépend du prix unitaire et de la quantité choisie.",

    'payment.offer4.badge': 'Offre 4',
    'payment.offer4.title': 'Analyse avec synthèse IA',
    'payment.offer4.desc': "Choisissez le nombre d'analyses avec synthèse IA. Le total dépend du prix unitaire et de la quantité choisie.",

    'payment.delivery.simple': 'Livraison : rapport brut (PDF).',
    'payment.delivery.withSummary': 'Livraison : rapport + synthèse (PDF + résumé).',

    'payment.choose': 'Souscrire',
    'payment.proceed': 'Souscrire',
    'payment.field.quantity': 'Nombre :',
    'payment.total': 'Total :',
    'payment.confirm': 'Confirmer',
    'payment.reset': 'Réinitialiser',
    'payment.cgv': 'J\'ai lu et accepté les conditions générales de vente',

    'payment.alert.selectedOffer': 'Offre sélectionnée :',
    'payment.alert.confirmation': 'Confirmation :',

    'payment.status.title': 'Statut de la commande',
    'payment.status.success': 'Paiement confirmé',
    'payment.status.failed': 'Paiement échoué',
    'payment.status.pending': 'Paiement en cours de traitement',
    'payment.status.unknown': 'Statut du paiement inconnu',
    'payment.status.order': 'Commande',
    'payment.processing': 'Redirection vers CMI...',
    'payment.error': 'Une erreur est survenue lors du paiement.',
    'payment.result.title.success': 'Paiement confirmé',
    'payment.result.title.failed': 'Paiement échoué',
    'payment.result.title.pending': 'Paiement en attente',
    'payment.result.message.success': 'Votre commande est validée et vos crédits ont été mis à jour.',
    'payment.result.message.failed': 'Le paiement a été refusé ou annulé. Vous pouvez réessayer.',
    'payment.result.message.pending': 'Le paiement est en cours de confirmation serveur. Cette page se met à jour automatiquement.',
    'payment.result.refreshHint': 'Vérification en cours...',
    'payment.result.verifyError': 'Impossible de vérifier la commande. Veuillez relancer le paiement depuis votre espace.',
    'payment.result.cta.backPayment': 'Retour au paiement',
    'payment.result.cta.home': 'Retour à l’accueil',
    'payment.startAnalysis': 'Commencer l’analyse',
    'payment.success.merci': "Merci pour votre achat. Vos crédits ont été ajoutés à votre compte avec succès. Vous pouvez dès à présent commencer vos analyses.",



    'remboursement.title': 'Demande de remboursement',
    'remboursement.info': 'Veuillez remplir ce formulaire. Notre équipe examinera votre demande sous 48h.',
    'remboursement.userNam': 'Nom complet',
    'remboursement.tel': 'Téléphone',
    'remboursement.motif': 'Motif de la demande',
    'remboursement.motif.placeholder': 'Expliquez brièvement votre demande...',
    'remboursement.submit': 'Soumettre la demande',
    'remboursement.submit.ing': 'Envoi en cours...',
    'remboursement.annuler': 'Annuler',
    'remboursement.notification.succe': "Votre demande a bien été envoyée avec succès.",
    'remboursement.notification.error': "Une erreur est survenue lors de l'envoi de votre demande. Veuillez réessayer plus tard.",
    'remboursement.btn.openForm': 'Signaler un problème ou demander un remboursement',


    'currency.mad': 'Dh',
    'user.default': 'utilisateur',
    'brand.name': 'FECAnalytics',
    'lang.toggle': 'Langue',

    'login.title': 'Connexion',
    'login.register': "S'inscrire",
    'login.login': 'Se connecter',
    'login.register': "S'incrire",
    'login.alreadyAccount': 'Déjà un compte ? Connectez-vous',
    'login.noAccount': "Vous n'avez pas de compte ? Inscrivez-vous",
    'login.emailVerification': "Renvoyer l'email de vérification",
    'login.pwdForgot': 'Mot de passe oublié ?',
    'login.password': 'Mot de passe',
    'login.passwordConfirme': 'Confirmer votre mot de passe',
    'login.emailConfireme': 'Confirmer votre Email',
    'login.Chargement': 'Chargement...',
    'login.username': "Nom d'utilisateur",
    'login.err': 'Veuillez vérifier vos informations, elles sont incorrectes.',
    'login.success': 'Inscription réussie ! Un email de vérification vous a été envoyé. Veuillez valider votre compte avant de vous connecter.',
    'auth.login_error': 'Veuillez vérifier vos informations, elles sont incorrectes.',


    'footer.title': 'Solution innovante de gestion et d’analyse du Fichier des Écritures Comptables, conforme aux exigences légales.',
    'footer.quickLinks': 'Liens rapides',
    'footer.legal': 'Légal',
    'footer.mentions': 'Mentions légales',
    'footer.privacy': 'Politique de confidentialité',
    'footer.terms': 'Conditions d’utilisation',
    'footer.cgv': 'Conditions générales de vente',
    'footer.guide': "Guide d'utilisation",
    'footer.copy': 'Tous droits réservés.',

    'footer.contact': 'Contact',
    'footer.contact.emailValue': 'contact@fecanalytics.cloud',
    'footer.contact.phoneValue': '+212 780 38 17 53',
    'footer.contact.addressValue': ' ',
    'footer.contact.link': 'Formulaire de contact',

    'links.faq': 'FAQ',
    'links.simulator': 'Simulateur',
    'links.optimizer': 'Optimisation',
    'links.home': 'Accueil',
    'links.features': 'Fonctionnalités',
    'links.about': 'À propos',
    'links.pricing': 'Tarification',

    // Hero
    'hero.metaTitle': 'Analyse intelligente des fichiers FEC et audit fiscal automatisé',
    'hero.metaDescription': 'Analyse intelligente des fichiers FEC et audit fiscal automatisé. Sécurisez votre comptabilité avec FECAnalytics.',
    'hero.titleDefault': 'Anticipez, maîtrisez et réussissez votre contrôle fiscal',
    'hero.subtitleExplicit': 'Préparez-vous, maîtrisez vos données et transformez le contrôle fiscal en simple formalité. Vous n\'avez pas de FEC, vous pouvez aussi soumettre vos journaux comptables pour analyse.',
    'hero.benefit': 'Gagnez 70% de temps sur vos analyses FEC.',
    'hero.cta': "Démarrez l'analyse",
    'hero.demoCta': 'Voir une démo',

    // Services
    'services.title': 'Fonctionnalités',
    'services.card1.title': 'Vérifications de conformité structurelle',
    'services.card1.desc': "Ce processus vise à vérifier l'intégrité, l'exactitude et l'exhaustivité du fichier comptable.",
    'services.card1.alt': 'Conformité et protection',
    'services.card2.title': 'Cohérence comptable globale',
    'services.card2.desc': "Ces tests ont pour but d'assurer l'intégrité, la cohérence et la conformité des écritures comptables.",
    'services.card2.alt': 'Cohérence comptable',
    'services.card3.title': 'Analyse fiscale et comptable',
    'services.card3.desc': "Générez un rapport d'audit détaillé qui retrace les anomalies comptables potentielles.",
    'services.card3.alt': 'Analyse et résultats',
    'services.card4.title': 'Détection avancée d’anomalies',
    'services.card4.desc': "Un algorithme d'intelligence artificielle identifie les schémas suspects.",
    'services.card4.alt': 'Détection avancée',
    'services.card5.title': 'Optimisation légale',
    'services.card5.desc': 'Des recommandations personnalisées pour améliorer la gestion comptable et fiscale.',
    'services.card5.alt': 'Optimisation',
    'services.card6.title': 'Veille fiscale',
    'services.card6.desc': 'Restez informé des dernières évolutions réglementaires et fiscales.',
    'services.card6.alt': 'Veille fiscale',
    'services.card7.title': 'Simulateur multi-juridictions',
    'services.card7.desc': 'Un outil interactif pour modéliser différents scénarios comptables et fiscaux.',
    'services.card7.alt': 'Simulateur multi-juridictions',
    'services.badge.popular': 'Plus utilisé',
    'services.badge.new': 'Nouveau',
    'services.badge.soon': 'Bientôt',

    // À savoir
    'asavoir.title': 'À savoir',
    'asavoir.heading': 'Obligations légales liées au Fichier des Écritures Comptables (FEC) au Maroc',
    'asavoir.p1': "Au Maroc, dans le cadre d’un contrôle fiscal, toute entreprise qui tient sa comptabilité au moyen de systèmes informatisés est tenue de présenter, à la demande de l’administration fiscale, une copie dématérialisée de ses écritures comptables. Cette obligation découle des dispositions du Code Général des Impôts (CGI), notamment l’article 210, qui encadre les modalités de présentation de la comptabilité en cas de vérification.",
    // 'asavoir.format': "Le fichier produit doit respecter les normes techniques fixées par l’administration fiscale marocaine. L’arrêté du 25 janvier 2016 précise les modalités de génération et de remise du FEC (Fichier des Écritures Comptables), ainsi que les champs et structures exigés. Un fichier non conforme peut être considéré comme une absence de présentation régulière de la comptabilité.",
    'asavoir.sanctions.title': 'Sanctions en cas de manquement',
    'asavoir.sanctions.items': [
      "Une amende de 5 000 dirhams par exercice non remis, conformément à l’article 210 du CGI ;",
      "L’évaluation d’office du résultat fiscal (article 213 du CGI) ;",
      "L’application de pénalités et majorations (articles 186 et suivants du CGI)."
    ],
    'asavoir.examen.title': 'Examen de comptabilité à distance',
    'asavoir.examen.p': "L’administration fiscale peut procéder à un examen de comptabilité à distance, en utilisant les données contenues dans le FEC. Le défaut de transmission du fichier dans le délai imparti peut entraîner des sanctions similaires à celles ci-dessus.",
    'asavoir.proc.p': "Depuis l’introduction de la procédure d’examen de comptabilité (article 212 bis du CGI, instauré par la Loi de finances 2018), l’administration peut désormais effectuer une vérification à distance, sur la base du FEC transmis par l’entreprise. Dans ce cas, le délai de réponse est de 30 jours à compter de la notification de la demande. Le défaut de transmission entraîne l’application des amendes précitées.",
    'asavoir.refs.title': 'Références utiles',
    'asavoir.refs.items': [
      'Le Code Général des Impôts (articles 210 à 213) ;',
      'L’arrêté du 25 janvier 2016 fixant le contenu et le format du FEC ;',
      'Les circulaires de la DGI sur l’examen de comptabilité et la dématérialisation.'
    ],

    // Demo + Offer
    'demo.aria': 'Démonstration et offre',
    'demo.title': 'Démo',
    'demo.play': 'Lire la vidéo',
    'demo.offer.badge1': 'Offre',
    'demo.offer.badge2': 'Payante',
    'demo.desc': 'Importez vos journaux ou fichiers FEC et obtenez :',
    'demo.b1': 'Une analyse complète et automatisée',
    'demo.b2': 'Un rapport détaillé et professionnel',
    'demo.b3': 'Un téléchargement immédiat de vos résultats',
    'demo.cta': 'Analysez',

    'demo.aria': 'Démonstration et offre',
    'demo.title': 'Démonstration',
    'demo.play': 'Lire la vidéo',
    'demo.offer.badge1': 'Offre',
    'demo.offer.badge2': 'Payante',
    'demo.desc': 'Importez vos journaux ou fichiers FEC et obtenez :',
    'demo.b1': 'Une analyse complète et automatisée',
    'demo.b2': 'Un rapport détaillé et professionnel',
    'demo.b3': 'Un téléchargement immédiat de vos résultats',
    'demo.cta': 'Paiement',

    // Pricing
    'pricing.offer': 'Offre',
    'pricing.priceLine': 'Paiement unique par fichier analysé',
    'pricing.cta': 'Analysez',

    // Stats
    'stats.analyzed': 'Fichiers analysés',
    'stats.users': 'Utilisateurs',
    'stats.files': 'Fichiers',
    'stats.subscriptions': 'Abonnements',
    'stats.clients': 'Clients satisfaits',
    'stats.countries': 'Pays desservis',
    'stats.satisfaction': 'Taux de satisfaction',

    // Contact
    'contact.title': 'Vos coordonnées',
    'contact.civ': 'Civilité',
    'contact.civ.choose': 'Choisir…',
    'contact.civ.mr': 'Monsieur',
    'contact.civ.ms': 'Madame',
    'contact.firstname': 'Prénom',
    'contact.lastname': 'Nom',
    'contact.email': 'Email',
    'contact.email.placeholder': 'Adresse mail',
    'contact.phone': 'Téléphone mobile',
    'contact.phone.placeholder': 'Téléphone mobile',
    'contact.phone.title': 'Numéro de téléphone valide (chiffres, espaces, +, -, . , () autorisés)',
    'contact.address': 'Adresse',
    'contact.address.placeholder': '(numéro et nom de rue)',
    'contact.postcode': 'Code postal',
    'contact.postcode.placeholder': 'Code postal',
    'contact.country': 'Pays',
    'contact.country.choose': 'Sélectionnez un pays…',
    'contact.city': 'Ville',
    'contact.city.placeholder': 'Ville',
    'contact.message': 'Message',
    'contact.message.placeholder': 'Votre message...',
    'contact.send': 'Envoyer',
    'contact.sending': 'Envoi…',
    'contact.alert.missing': "Veuillez renseigner au minimum le prénom, le nom et l'email.",
    'contact.alert.serverPrefix': 'Erreur serveur: ',
    'contact.alert.unable': 'Impossible d\'enregistrer vos informations. Vérifiez le serveur puis réessayez.',
    'contact.alert.thanks': 'Merci ! Vos informations ont été enregistrées.',

    // Historique
    'history.title': 'Mon espace',
    'history.header.aria': 'En-tête de l\'espace utilisateur',
    'history.user': 'Utilisateur',
    'history.email': 'Email',
    'history.btn.newAnalysis': 'Nouvelle analyse',
    'history.subscription.title': 'Mon abonnement',
    'history.subscription.active': 'ACTIF',
    'history.subscription.inactive': 'INACTIF',
    'history.subscription.credits': 'Crédits fichiers',
    'history.stats.analyses': 'Analyses effectuées',
    'history.stats.files': 'Fichiers traités',
    'history.stats.lastActivity': 'Dernière activité',
    'history.loading': 'Chargement des données...',
    'history.errorPrefix': 'Erreur',
    'history.unknownError': 'Erreur inconnue',
    'history.notAvailable': 'N/A',
    'history.files.title': 'Historique des fichiers',
    'history.files.empty': 'Aucun historique',
    'history.files.cta': 'Lancer une analyse',
    'history.files.more': 'Afficher plus ({count} fichiers restants)',
    // 'history.files.selection.hint': 'Cochez pour sÃ©lectionner plusieurs fichiers. Shift + clic pour sÃ©lectionner un intervalle.',
    'history.files.selection.count': '{count} fichier(s) sÃ©lectionnÃ©(s)',
    'history.files.selection.selectVisible': 'Sélectionner la liste affichée',
    'history.files.selection.clearVisible': 'Tout désélectionner',
    'history.files.selection.checkbox': 'Sélectionner',
    'history.files.selection.help': 'Aucun fichier sélectionné',
    'history.files.delete.cta': 'Supprimer la sélection',
    'history.files.delete.progress': 'Suppression...',
    'history.files.delete.success': '{count} fichier(s) supprimé(s).',
    'history.files.delete.partial': '{deleted} supprimé(s). {missing} introuvable(s).',
    'history.files.delete.error': 'Impossible de supprimer la sélection.',
    'history.files.delete.confirm.one': 'Supprimer "{name}" ? Cette action est définitive.',
    'history.files.delete.confirm.many': 'Supprimer {count} fichiers sélectionnés ? Cette action est définitive.',
    'history.files.name': 'Fichier',
    'history.files.date': 'Date',
    'history.files.type': 'Type',
    'history.files.status': 'Statut',
    'history.files.viewReport': 'Voir le rapport',
    'history.filters.year': 'Année',
    'history.filters.month': 'Mois',
    'history.filters.type': 'Type de fichier',
    'history.filters.sort': 'Tri',
    'history.filters.all': 'Tous',
    'history.filters.fec': 'FEC',
    'history.filters.journaux': 'Journaux',
    'history.filters.sortDateDesc': 'Date dÃ©croissante',
    'history.filters.sortDateAsc': 'Date croissante',
    'history.filters.sortNameAsc': 'Nom Aâ†’Z',
    'history.filters.sortNameDesc': 'Nom Zâ†’A',
    'history.filters.sortSizeDesc': 'Taille dÃ©croissante',
    'history.filters.sortSizeAsc': 'Taille croissante',
    'history.filters.list': 'Liste',
    'history.filters.grid': 'Cartes',
    'history.status.done': 'Terminé',
    'history.status.error': 'Erreur',
    'history.status.pending': 'En attente',
    'history.status.paid': 'Payé',
    'history.payments.title': 'Historique des paiements',
    'history.payments.empty': 'Aucun paiement enregistré.',
    'history.payments.item': 'Achat de {count} fichiers',
    'history.payments.more': 'Afficher plus ({count} paiements restants)',
    // Simulator
    'simulator.title': 'Simulateur de retenue à la source',
    'simulator.source': 'Pays source',
    'simulator.destination': 'Pays de destination',
    'simulator.amount': 'Montant',
    'simulator.submit': 'Lancer la simulation',
    'simulator.calculating': 'Calcul...',
    'simulator.info': 'Information:',
    'simulator.inputs': 'Entrées:',
    'simulator.rate': 'Taux appliqué:',
    'simulator.withholding': 'Retenue:',
    'simulator.net': 'Net:',


    // Raporrte
    'result.1': 'Généré',
    'result.2': 'Période',
    'result.3': 'Utilisateur',
    'result.4': 'E-mail',
    'result.5': 'Télécharger',
    'result.6': 'Téléchargement...',
    'result.7': 'Nouvelle analyse',
    'result.8': 'Total des anomalies',
    'result.9': 'Effacer',
    'result.10': 'Chargement des données…',
    'result.11': 'Synthèse de l’analyse',
    'result.12': 'Données graphiques',
    'result.13': 'Montants par journal',
    'result.14': 'Évolution mensuelle',
    'result.15': 'Top 10 des comptes',
    'result.16': 'Anomalies / Lignes',
    'result.17': 'Aucune anomalie détectée',
    'result.18': 'Autres lignes (affichage partiel)',
    'result.19': 'Impossible de charger les résultats',
    'result.20': '...',
    'result.21': 'et',
    'result.22': 'autres',

    // PDF report
    'pdf.common.yes': 'Oui',
    'pdf.common.no': 'Non',
    'pdf.common.na': 'N/A',
    'pdf.common.datePlaceholder': 'jj/mm/aaaa',
    'pdf.document.title': "Rapport d'analyse FEC",
    'pdf.document.subject': "Rapport d'analyse FEC",
    'pdf.document.author': 'FECAnalytics',
    'pdf.cover.title': 'Rapport',
    'pdf.cover.pageLabel': 'Couverture',
    'pdf.cover.tag': "Rapport d'analyse FEC",
    'pdf.cover.period': 'Periode',
    'pdf.cover.analysisDate': "Date analyse",
    'pdf.cover.user': 'Utilisateur',
    'pdf.cover.exportDate': 'Date export',
    'pdf.reportInfo.title': 'Informations du rapport',
    'pdf.reportInfo.subtitle': "Metadonnees de generation et contexte d'analyse.",
    'pdf.summary.title': "Synthese de l'analyse",
    'pdf.summary.subtitle': 'Synthese globale et synthese par section.',
    'pdf.summary.generatedTitle': 'Synthese IA',
    'pdf.summary.empty': 'Aucune synthese IA disponible.',
    'pdf.metrics.anomaliesDetected': 'Anomalies detectees',
    'pdf.metrics.usefulSubsections': 'Sous-sections utiles',
    'pdf.metrics.status': 'Etat',
    'pdf.status.ok': 'OK',
    'pdf.status.watch': 'A surveiller',
    'pdf.section.summaryTitle': 'Resume',
    'pdf.section.keyPoints': 'Points cles',
    'pdf.section.recurringSignals': 'Signaux recurrents',
    'pdf.section.examples': 'Exemples',
    'pdf.section.empty': "Aucun element exploitable n'a ete retenu pour cette section.",
    'pdf.section.noDetailedAnomaly': 'Aucune anomalie detaillee',
    'pdf.section.ordinal': 'Section {index}',
    'pdf.section.fallback': 'Section {index}',
    'pdf.section.hiddenChildren': '{count} sous-point(s) supplementaire(s) masque(s) pour conserver un format de synthese.',
    'pdf.section.hiddenSubsections': '{count} sous-section(s) supplementaire(s) non affichee(s) dans le PDF.',
    'pdf.subsection.fallback': 'Sous-section',
    'pdf.info.userName': 'Nom utilisateur',
    'pdf.info.email': 'Email',
    'pdf.info.userId': 'Identifiant utilisateur',
    'pdf.info.reportReference': 'Reference dossier',
    'pdf.info.generatedAt': 'Date/heure generation',
    'pdf.info.analyzedPeriod': 'Periode analysee',
    'pdf.info.analysisMode': 'Mode analyse',
    'pdf.info.chartPlan': 'Plan comptable',
    'pdf.params.mode': 'Mode',
    'pdf.params.plan': 'Plan',
    'pdf.params.previousYear': 'N-1',
    'pdf.params.files': 'Fichiers',
    'pdf.sections.Conformite_et_Qualite': 'Conformité Et Qualité',
    'pdf.sections.Coherence_Comptable': 'Cohérence Comptable',
    'pdf.sections.Analyse_Financiere_Avancee': 'Analyse Financière Avancée',

    // Optimizer
    'optimizer.title': "Générateur d’optimisation légale",
    'optimizer.country': 'Pays / Zone',
    'optimizer.activity': 'Activité principale',
    'optimizer.activity.placeholder': 'Ex: SaaS B2B',
    'optimizer.revenue': "Chiffre d'affaires annuel",
    'optimizer.staff': 'Effectif (salariés)',
    'optimizer.submit': 'Générer',
    'optimizer.generating': 'Génération...',
    'optimizer.result.title': 'Résultat',

    // Generic errors
    'errors.api': "Erreur lors de l'appel API.",
    'errors.network': 'Erreur réseau/API. Réessayez.',

    // Documentation
    'doc.meta.title': 'Documentation – Guide d’utilisation FECAnalytics',
    'doc.meta.desc': 'Guide officiel pour utiliser FECAnalytics : upload de fichiers FEC, analyse comptable, mapping des colonnes et génération des rapports fiscaux.',
    'doc.hero.title': 'Documentation FECAnalytics',
    'doc.hero.subtitle': 'Guide officiel d’utilisation de la plateforme d’analyse intelligente des fichiers FEC.',
    'doc.hero.start': 'Commencer une analyse',
    'doc.hero.login': 'Se connecter',

    'doc.intro.title': 'Présentation rapide',
    'doc.intro.desc': 'FECAnalytics est une solution innovante qui vous permet :',
    'doc.intro.item1': 'D’analyser des fichiers journaux/FEC.',
    'doc.intro.item2': 'De détecter des anomalies comptables.',
    'doc.intro.item3': 'D’anticiper les contrôles fiscaux.',
    'doc.intro.item4': 'D’automatiser les vérifications.',

    'doc.step1.title': '1. Création du compte',
    'doc.step1.desc': "L'utilisateur doit d'abord <strong>créer un compte</strong>. Une fois inscrit et connecté, il peut accéder au tableau de bord de la plateforme. Notez que les analyses fonctionnent grâce à un système de crédits.",

    'doc.step2.title': '2. Achat de crédits',
    'doc.step2.desc': 'Une analyse coûte <strong>1000 MAD</strong>. Un crédit équivaut à une analyse complète. Une analyse couvre une période comptable maximale d\'un an, définie par la date d\'ouverture et de clôture.',
    'doc.step2.note': "1 Crédit = 1 Analyse = 1 Année d\'exercice",

    'doc.step3.title': '3. Upload des fichiers',
    'doc.step3.desc': 'L\'utilisateur doit uploader son fichier journal ou FEC en le sélectionnant depuis son appareil. Il est essentiel de vérifier que le fichier est complet et au bon format avant l\'envoi.',

    'doc.step4.title': '4. Plan Comptable',
    'doc.step4.desc': 'Actuellement, la plateforme supporte exclusivement le <strong>PCM (Plan Comptable Marocain)</strong> pour ses analyses de conformité.',
    'doc.step4.note': '<strong>Note :</strong> D’autres plans comptables internationaux pourront être ajoutés prochainement.',

    'doc.step5.title': '5. Mapping des colonnes',
    'doc.step5.desc': "Lors de l'importation de fichiers non standard, l'utilisateur doit associer visuellement les colonnes de son fichier aux champs requis par notre algorithme grâce à des listes déroulantes.",
    'doc.step5.field1': 'Code Journal',
    'doc.step5.field2': 'Date',
    'doc.step5.field3': 'Compte',
    'doc.step5.field4': 'Libellé',
    'doc.step5.field5': 'Débit',
    'doc.step5.field6': 'Crédit',
    'doc.step5.footer': 'Cette étape permet de faire correspondre avec précision vos données internes aux attentes de FECAnalytics.',

    'doc.launch.title': 'Lancement de l’analyse',
    'doc.launch.desc': "Une fois tous les champs renseignés, il suffit de cliquer sur le bouton <strong>\"Envoyer l’analyse\"</strong>. Le traitement démarre automatiquement. Vous serez ensuite redirigé vers l'interface de rapport.",

    'doc.report.title': 'Rapport final',
    'doc.report.desc': "À la fin du traitement, un rapport interactif complet est généré affichant les anomalies détectées. Un bouton est mis à disposition pour <strong>télécharger le rapport au format PDF</strong>.",

    'doc.history.title': 'Historique & Sauvegarde',
    'doc.history.desc': "Le fonctionnement de l\'historique répond à des normes strictes de confidentialité :",
    'doc.history.item1': 'Le rapport reste disponible tant qu’aucune nouvelle analyse n’est effectuée.',
    'doc.history.item2': '<strong>Une nouvelle analyse remplace automatiquement l’historique précédent.</strong>',
    'doc.history.item3': 'Il est donc <strong>fortement recommandé de télécharger immédiatement le rapport</strong> dès sa génération.',

    'doc.faq.title': 'Foire Aux Questions',
    'doc.faq.q1': 'Quels fichiers sont supportés ?',
    'doc.faq.a1': 'Nous supportons les fichiers journaux et les Fichiers des Écritures Comptables (FEC) aux formats standard (.csv, .txt, .xlsx).',
    'doc.faq.q2': 'Combien coûte une analyse ?',
    'doc.faq.a2': "Chaque analyse coûte 1000 MAD et correspond à un crédit. L'achat de crédits s'effectue directement depuis la plateforme de manière sécurisée.",
    'doc.faq.q3': 'Quelle est la durée maximale d’analyse ?',
    'doc.faq.a3': 'Une analyse couvre une période comptable maximale d\'une année (12 mois), délimitée par une date d\'ouverture et une date de clôture.',
    'doc.faq.q4': 'Puis-je récupérer un ancien rapport ?',
    'doc.faq.a4': 'Oui, le dernier rapport reste disponible dans votre historique tant qu\'aucune nouvelle analyse n\'est effectuée. Il est cependant recommandé de le télécharger.',
    'doc.faq.q5': 'Quels plans comptables sont disponibles ?',
    'doc.faq.a5': "Actuellement, seul le Plan Comptable Marocain (PCM) est supporté. D\'autres plans seront ajoutés prochainement.",
    'doc.faq.q6': "Combien de temps dure l\\'analyse ?",
    'doc.faq.a6': "L\'analyse de conformité et l\'audit via notre algorithme sont généralement très rapides et ne prennent que quelques minutes, selon la taille de votre fichier.",

    'doc.cta.title': 'Prêt à optimiser votre comptabilité ?',
    'doc.cta.desc': 'Rejoignez les professionnels qui sécurisent leur conformité fiscale grâce à l\'intelligence artificielle.',
    'doc.cta.btn1': 'Commencer une analyse',
    'doc.cta.btn2': 'Créer un compte',

    // FAQ
    'faq.title': 'FAQ',
    'faq.subtitle': 'Questions les plus posées sur la plateforme et son fonctionnement.',
    'faq.fallback.q1': 'Comment fonctionne l’analyse ?',
    'faq.fallback.a1': 'Déposez vos fichiers puis lancez l’analyse. Un rapport est généré automatiquement.',
    'faq.fallback.q2': 'Mes données sont-elles sécurisées ?',
    'faq.fallback.a2': 'Oui. Nous stockons uniquement ce qui est nécessaire et chiffrons les échanges.',
    'faq.fallback.q3': 'Qui peut accéder à mes données ?',
    'faq.fallback.a3': 'Seul votre compte peut consulter vos rapports. Vous pouvez demander la suppression à tout moment.',
    'faq.fallback.q4': 'Dois-je créer un compte pour utiliser la plateforme ?',
    'faq.fallback.a4': 'Oui, un compte est nécessaire pour déposer vos fichiers et accéder aux fonctionnalités du simulateur.',
  },
  en: {

    // navbar





    // Documentation
    'doc.meta.title': 'Documentation – FECAnalytics User Guide',
    'doc.meta.desc': 'Official guide to use FECAnalytics: FEC files upload, accounting analysis, column mapping, and tax reports generation.',
    'doc.hero.title': 'FECAnalytics Documentation',
    'doc.hero.subtitle': 'Official user guide for the intelligent FEC file analysis platform.',
    'doc.hero.start': 'Start an analysis',
    'doc.hero.login': 'Sign in',

    'doc.intro.title': 'Quick Overview',
    'doc.intro.desc': 'FECAnalytics is an innovative solution that allows you to:',
    'doc.intro.item1': 'Analyze journal/FEC files.',
    'doc.intro.item2': 'Detect accounting anomalies.',
    'doc.intro.item3': 'Anticipate tax audits.',
    'doc.intro.item4': 'Automate verifications.',

    'doc.step1.title': '1. Account Creation',
    'doc.step1.desc': "The user must first <strong>create an account</strong>. Once registered and logged in, they can access the platform's dashboard. Note that analyses work using a credit system.",

    'doc.step2.title': '2. Purchasing Credits',
    'doc.step2.desc': 'An analysis costs <strong>1000 MAD</strong>. One credit equals one full analysis. An analysis covers a maximum accounting period of one year, defined by the opening and closing date.',
    'doc.step2.note': '1 Credit = 1 Analysis = 1 Fiscal Year',

    'doc.step3.title': '3. Uploading Files',
    'doc.step3.desc': 'The user must upload their journal or FEC file by selecting it from their device. It is essential to ensure that the file is complete and in the correct format before uploading.',

    'doc.step4.title': '4. Chart of Accounts',
    'doc.step4.desc': 'Currently, the platform exclusively supports the <strong>PCM (Moroccan Chart of Accounts)</strong> for its compliance analyses.',
    'doc.step4.note': '<strong>Note:</strong> Other international charts of accounts may be added soon.',

    'doc.step5.title': '5. Column Mapping',
    'doc.step5.desc': "When importing non-standard files, the user must visually map their file's columns to the fields required by our algorithm using dropdown lists.",
    'doc.step5.field1': 'Journal Code',
    'doc.step5.field2': 'Date',
    'doc.step5.field3': 'Account',
    'doc.step5.field4': 'Label',
    'doc.step5.field5': 'Debit',
    'doc.step5.field6': 'Credit',
    'doc.step5.footer': "This step ensures your internal data accurately matches FECAnalytics' expectations.",

    'doc.launch.title': 'Launching the Analysis',
    'doc.launch.desc': 'Once all fields are filled, simply click the <strong>"Submit analysis"</strong> button. Processing starts automatically. You will then be redirected to the report interface.',

    'doc.report.title': 'Final Report',
    'doc.report.desc': 'At the end of processing, a complete interactive report is generated displaying the detected anomalies. A button is available to <strong>download the report in PDF format</strong>.',

    'doc.history.title': 'History & Backup',
    'doc.history.desc': 'The history operates under strict confidentiality standards:',
    'doc.history.item1': 'The report remains available as long as no new analysis is performed.',
    'doc.history.item2': '<strong>A new analysis automatically replaces the previous history.</strong>',
    'doc.history.item3': 'Therefore, it is <strong>highly recommended to download the report immediately</strong> upon generation.',

    'doc.faq.title': 'Frequently Asked Questions',
    'doc.faq.q1': 'Which files are supported?',
    'doc.faq.a1': 'We support journal files and Accounting Entries Files (FEC) in standard formats (.csv, .txt, .xlsx).',
    'doc.faq.q2': 'How much does an analysis cost?',
    'doc.faq.a2': 'Each analysis costs 1000 MAD and corresponds to one credit. Credit purchases are made securely directly on the platform.',
    'doc.faq.q3': 'What is the maximum duration for an analysis?',
    'doc.faq.a3': 'An analysis covers a maximum accounting period of one year (12 months), defined by an opening date and a closing date.',
    'doc.faq.q4': 'Can I retrieve an old report?',
    'doc.faq.a4': 'Yes, the latest report remains available in your history as long as no new analysis is performed. However, downloading it is recommended.',
    'doc.faq.q5': 'Which charts of accounts are available?',
    'doc.faq.a5': 'Currently, only the Moroccan Chart of Accounts (PCM) is supported. Other charts will be added soon.',
    'doc.faq.q6': 'How long does the analysis take?',
    'doc.faq.a6': 'Compliance analysis and auditing via our algorithm are generally very fast and take only a few minutes, depending on the size of your file.',

    'doc.cta.title': 'Ready to optimize your accounting?',
    'doc.cta.desc': 'Join professionals who secure their tax compliance using artificial intelligence.',
    'doc.cta.btn1': 'Start an analysis',
    'doc.cta.btn2': 'Create an account',

    // MultiStepForm
    'msf.langue': 'Anglais',
    'msf.title': 'Analysis form',
    'msf.loading': 'Please wait',
    'msf.loading.detailed': 'Analysis in progress... it can take up to 1â€“2 minutes depending on file size.',
    'msf.loading.stepUpload': 'Uploading files securely',
    'msf.loading.stepCheck': 'Compliance checks',
    'msf.loading.stepAnalysis': 'Analysis and processing',
    'msf.loading.stepReport': 'Generating results',
    'msf.draft.resumePrompt': 'Resume your last saved draft?',
    'msf.steps.import': 'Import, general info and compliance checks',
    'msf.section.importGeneral': 'Import & General information',
    'msf.section.compliance': 'Compliance',
    'msf.btn.loadFec': 'Load a FEC file',
    'msf.btn.loadJournals': 'Load journals',
    'msf.btn.importPrevFec': 'Import a previous FEC',
    'msf.btn.clearSelection': 'Clear selection',
    'msf.hint.selectOneFile': 'Select exactly one file',
    'msf.hint.selectPrevFec': 'Select a previous-year FEC file',
    'msf.hint.upTo10Files': 'Up to 10 files',
    'msf.hint.csvxlsx': '(CSV/XLSX accepted)',
    'msf.label.chart': 'Chart of accounts used',
    'msf.option.select': '-- Select --',
    'msf.label.openDate': 'Fiscal year opening date',
    'msf.label.closeDate': 'Fiscal year closing date',
    'msf.placeholder.date': 'dd/mm/yyyy',
    'msf.c.label.journal_code': 'Journal code',
    'msf.c.label.journal_label': 'Journal label',
    'msf.c.label.entry_number': 'Entry number',
    'msf.c.label.entry_date': 'Entry date',
    'msf.c.label.account_number': 'Account number',
    'msf.c.label.account_label': 'Account label',
    'msf.c.label.entry_label': 'Entry label',
    'msf.c.label.document_ref': 'Document reference',
    'msf.c.label.currency': 'Document currency',
    'msf.c.label.document_date': 'Document date',
    'msf.c.label.debit_amount': 'Debit amount',
    'msf.c.label.credit_amount': 'Credit amount',
    'msf.c.label.validation_date': 'Entry validation date',
    'msf.c.placeholder.journal_code': 'journal_code',
    'msf.c.placeholder.journal_label': 'journal_label',
    'msf.c.placeholder.entry_number': 'entry_number',
    'msf.c.placeholder.entry_date': 'entry_date',
    'msf.c.placeholder.account_number': 'account_number',
    'msf.c.placeholder.account_label': 'account_label',
    'msf.c.placeholder.entry_label': 'entry_label',
    'msf.c.placeholder.document_ref': 'document_ref',
    'msf.c.placeholder.currency': 'currency',
    'msf.c.placeholder.document_date': 'document_date',
    'msf.c.placeholder.debit_amount': 'debit_amount',
    'msf.c.placeholder.credit_amount': 'credit_amount',
    'msf.c.placeholder.validation_date': 'validation_date',
    'msf.err.chooseImportMode': 'Please choose an import option.',
    'msf.err.selectExactlyOneFec': 'Select exactly one (1) FEC file.',
    'msf.err.prevFecRequired': 'If selected, please add the previous-year FEC.',
    'msf.err.atLeastOneFile': 'At least one file is required.',
    'msf.err.maxFiles': 'Maximum 10 files allowed.',
    'msf.err.required': 'Required field',
    'msf.err.closeAfterOpen': 'Closing date must be after opening date.',
    'msf.err.intervalOneYear': 'The interval between opening and closing must be one year (365 to 366 days).',
    'msf.err.tooManyKeepFirst10': 'You selected more than 10 files. Only the first 10 were kept.',
    'msf.err.prevFecN1': 'Please select the prior-year FEC (N-1).',
    'msf.err.prefix': 'Error:',
    'msf.btn.submit': 'Submit',
    'msf.btn.cancel': 'Cancel',




    // Payment
    'payment.title': 'Payment',
    'payment.selectedPlan': 'Selected plan',
    'payment.connectedAs': 'Signed in as',
    'payment.back': 'Back',

    'payment.offer1.badge': 'Offer 1',
    'payment.offer1.title': 'Simple analysis without AI summary',
    'payment.offer1.desc': 'A simple analysis as-is, without AI summary. Ideal for a quick audit.',

    'payment.offer2.badge': 'Offer 2',
    'payment.offer2.title': 'Analysis with AI-generated report summary',
    'payment.offer2.desc': 'Full analysis with an AI-generated summary: highlights, recommendations, and actionable brief.',

    'payment.offer3.badge': 'Offer 3',
    'payment.offer3.title': 'Customizable Simple Analyses',
    'payment.offer3.desc': 'Choose the number of analyses. Total depends on unit price and selected quantity.',

    'payment.offer4.badge': 'Offer 4',
    'payment.offer4.title': 'Customizable Analyses with AI Summary',
    'payment.offer4.desc': 'Choose the number of analyses with AI summary. Total depends on unit price and selected quantity.',

    'payment.delivery.simple': 'Delivery: raw report (PDF).',
    'payment.delivery.withSummary': 'Delivery: report + summary (PDF + brief).',

    'payment.status.title': 'Order status',
    'payment.status.success': 'Payment confirmed',
    'payment.status.failed': 'Payment failed',
    'payment.status.pending': 'Payment is processing',
    'payment.status.unknown': 'Unknown payment status',
    'payment.status.order': 'Order',
    'payment.processing': 'Redirecting to CMI...',
    'payment.error': 'Payment error.',
    'payment.result.title.success': 'Payment confirmed',
    'payment.result.title.failed': 'Payment failed',
    'payment.result.title.pending': 'Payment pending',
    'payment.result.message.success': 'Your order is confirmed and your credits were updated.',
    'payment.result.message.failed': 'The payment was refused or cancelled. You can retry.',
    'payment.result.message.pending': 'Payment is being confirmed on server side. This page updates automatically.',
    'payment.result.refreshHint': 'Checking status...',
    'payment.result.verifyError': 'Unable to verify this order. Please restart payment from your account.',
    'payment.result.cta.backPayment': 'Back to payment',
    'payment.result.cta.home': 'Back to home',
    'payment.cgv': 'I have read and accept the General Terms and Conditions of Sale',
    'payment.startAnalysis': 'Start Analysis',
    'payment.success.merci': "Thank you for your purchase. Your credits have been successfully added to your account. You can now start your analyses.",

    'payment.choose': 'Choose',
    'payment.proceed': 'Choose',
    'payment.field.quantity': 'Quantity:',
    'payment.total': 'Total:',
    'payment.confirm': 'Confirm',
    'payment.reset': 'Reset',

    'payment.alert.selectedOffer': 'Selected offer:',
    'payment.alert.confirmation': 'Confirmation:',


    'remboursement.title': 'Refund Request',
    'remboursement.info': 'Please complete this form. Our team will review your request within 48 hours.',
    'remboursement.userNam': 'Full Name',
    'remboursement.tel': 'Phone Number',
    'remboursement.motif': 'Reason for Request',
    'remboursement.motif.placeholder': 'Briefly explain the reason for your request...',
    'remboursement.submit': 'Submit Request',
    'remboursement.submit.ing': 'Submitting...',
    'remboursement.annuler': 'Cancel',
    'remboursement.notification.succe': 'Your request has been submitted successfully.',
    'remboursement.notification.error': 'An error occurred while sending your request. Please try again later.',
    'remboursement.btn.openForm': 'Report an issue or request a refund',

    'currency.mad': 'MAD',
    'user.default': 'user',
    'brand.name': 'FECAnalytics',
    'nav.home': 'Home',
    'nav.features': 'Features',
    'nav.demo': 'Demo',
    'nav.pricing': 'Pricing',
    'nav.asavoir': 'Key points',
    'nav.contact': 'Contact',
    'nav.login': 'Sign in',
    'nav.logout': 'Sign out',
    'lang.toggle': 'Language',

    'login.title': 'Sign In',
    'login.register': 'Sign Up',
    'login.login': 'Sign In',
    'login.alreadyAccount': 'Already have an account? Sign In',
    'login.noAccount': "Don't have an account? Sign Up",
    'login.emailVerification': 'Resend verification email',
    'login.pwdForgot': 'Forgot password?',
    'login.password': 'Password',
    'login.passwordConfirme': 'Confirm your password',
    'login.emailConfireme': 'Confirm your email',
    'login.Chargement': 'Loading...',
    'login.username': 'Username',
    'login.err': 'Please check your information, it is incorrect.',
    'login.success': 'Registration successful! A verification email has been sent to you. Please verify your account before signing in.',
    'auth.login_error': 'Please check your information, it is incorrect.',

    'footer.title': 'Innovative solution for managing and analyzing the Accounting Entries File, compliant with legal requirements.',
    'footer.quickLinks': 'Quick links',
    'footer.legal': 'Legal',
    'footer.mentions': 'Legal notice',
    'footer.privacy': 'Privacy policy',
    'footer.terms': 'Terms of use',
    'footer.cgv': 'Terms of sale',
    'footer.guide': 'User guide',
    'footer.copy': 'All rights reserved.',

    'footer.contact': 'Contact',
    'footer.contact.emailValue': 'contact@fecanalytics.cloud',
    'footer.contact.phoneValue': '+212 780 38 17 53',
    'footer.contact.addressValue': ' ',
    'footer.contact.link': 'Contact form',

    'links.faq': 'FAQ',
    'links.simulator': 'Simulator',
    'links.optimizer': 'Optimization',
    'links.home': 'Home',
    'links.features': 'Features',
    'links.about': 'About',
    'links.pricing': 'Pricing',

    // Hero
    'hero.metaTitle': 'Intelligent FEC file analysis and automated tax audit',
    'hero.metaDescription': 'Intelligent FEC file analysis and automated tax audit. Secure your accounting with FECAnalytics.',
    'hero.titleDefault': 'Anticipate, Master, and Succeed in Your Tax Audit.',
    'hero.subtitleExplicit': 'Get prepared, master your data, and turn tax audits into a simple formality. If you don\'t have a FEC file, you can also submit your accounting journals for analysis.',
    'hero.benefit': 'Save 70% of time on your FEC analyses.',
    'hero.cta': 'Start analysis',
    'hero.demoCta': 'See a demo',

    // Services
    'services.title': 'Features',
    'services.card1.title': 'Structural compliance checks',
    'services.card1.desc': 'Verifies integrity, accuracy, and completeness of accounting file.',
    'services.card1.alt': 'Compliance and protection',
    'services.card2.title': 'Overall accounting consistency',
    'services.card2.desc': 'Ensures integrity, consistency, and compliance of accounting entries with good practice and regulatory requirements.',
    'services.card2.alt': 'Accounting consistency',
    'services.card3.title': 'Tax and accounting analysis',
    'services.card3.desc': 'Generate a detailed audit report that traces potential accounting anomalies.',
    'services.card3.alt': 'Analysis and results',
    'services.card4.title': 'Advanced anomaly detection',
    'services.card4.desc': 'An AI algorithm identifies suspicious patterns.',
    'services.card4.alt': 'Advanced detection',
    'services.card5.title': 'Legal optimization',
    'services.card5.desc': 'Personalized recommendations to improve accounting and tax management.',
    'services.card5.alt': 'Optimization',
    'services.card6.title': 'Tax watch',
    'services.card6.desc': 'Stay informed about the latest regulatory and tax changes.',
    'services.card6.alt': 'Tax watch',
    'services.card7.title': 'Multiâ€‘jurisdiction simulator',
    'services.card7.desc': 'An interactive tool to model different accounting and tax scenarios.',
    'services.card7.alt': 'Multiâ€‘jurisdiction simulator',
    'services.badge.popular': 'Most used',
    'services.badge.new': 'New',
    'services.badge.soon': 'Coming soon',

    // Key points
    'asavoir.title': 'Key points',
    'asavoir.heading': 'Legal obligations related to the FEC in Morocco',
    'asavoir.p1': 'In Morocco, as part of a tax audit, any company using computerized accounting must, upon request of the tax authority, provide a dematerialized copy of its accounting entries. This obligation stems from the General Tax Code (CGI), notably Article 210, which sets the rules for presenting accounting records during audits.',
    // 'asavoir.format': 'The file must comply with the technical standards set by the Moroccan tax administration. The decree of January 25, 2016 defines how to generate and submit the FEC as well as required fields and structure. A nonâ€‘compliant file may be considered as a failure to properly present accounting records.',
    'asavoir.sanctions.title': 'Penalties in case of nonâ€‘compliance',
    'asavoir.sanctions.items': [
      'A fine of 5,000 MAD per fiscal year not submitted (CGI Article 210);',
      'An official assessment of taxable income (CGI Article 213);',
      'Penalties and surcharges (CGI Articles 186 and following).'
    ],
    'asavoir.examen.title': 'Remote accounting audit',
    'asavoir.examen.p': 'The tax administration may carry out a remote examination using the data contained in the FEC. Failure to transmit the file within the allotted time may lead to similar penalties.',
    'asavoir.proc.p': 'Since the introduction of remote accounting examinations (CGI Article 212 bis, introduced by the 2018 Finance Law), the administration may now conduct audits remotely based on the submitted FEC. The response time is 30 days from notification. Failure to transmit triggers the aforementioned fines.',
    'asavoir.refs.title': 'Useful references',
    'asavoir.refs.items': [
      'General Tax Code (Articles 210 to 213);',
      'Decree of January 25, 2016 defining FEC content and format;',
      'DGI circulars on remote accounting audits and dematerialization.'
    ],

    // Demo + Offer
    'demo.aria': 'Demo and offer',
    'demo.title': 'Demo',
    'demo.play': 'Play video',
    'demo.offer.badge1': 'Offer',
    'demo.offer.badge2': 'Paid',
    'demo.desc': 'Import your journals or FEC files and get:',
    'demo.b1': 'A complete and automated analysis',
    'demo.b2': 'A detailed, professional report',
    'demo.b3': 'Immediate download of your results',
    'demo.cta': 'Payment',

    // Pricing
    'pricing.offer': 'Offer',
    'pricing.priceLine': 'Oneâ€‘time payment per analyzed file',
    'pricing.cta': 'Analyze',

    // Stats
    'stats.analyzed': 'Files analyzed',
    'stats.users': 'Users',
    'stats.files': 'Files',
    'stats.subscriptions': 'Subscriptions',
    'stats.clients': 'Happy clients',
    'stats.countries': 'Countries served',
    'stats.satisfaction': 'Satisfaction rate',

    // Contact
    'contact.title': 'Your details',
    'contact.civ': 'Title',
    'contact.civ.choose': 'Chooseâ€¦',
    'contact.civ.mr': 'Mr',
    'contact.civ.ms': 'Ms',
    'contact.firstname': 'First name',
    'contact.lastname': 'Last name',
    'contact.email': 'Email',
    'contact.email.placeholder': 'Email address',
    'contact.phone': 'Mobile phone',
    'contact.phone.placeholder': 'Mobile phone',
    'contact.phone.title': 'Valid phone number (digits, spaces, +, -, ., () allowed)',
    'contact.address': 'Address',
    'contact.address.placeholder': '(street number and name)',
    'contact.postcode': 'Postal code',
    'contact.postcode.placeholder': 'Postal code',
    'contact.country': 'Country',
    'contact.country.choose': 'Select a countryâ€¦',
    'contact.city': 'City',
    'contact.city.placeholder': 'City',
    'contact.message': 'Message',
    'contact.message.placeholder': 'Your message...',
    'contact.send': 'Send',
    'contact.sending': 'Sendingâ€¦',
    'contact.alert.missing': 'Please provide at least first name, last name, and email.',
    'contact.alert.serverPrefix': 'Server error: ',
    'contact.alert.unable': 'Unable to save your information. Check the server and try again.',
    'contact.alert.thanks': 'Thank you! Your information has been recorded.',

    // Historique
    'history.title': 'My space',
    'history.header.aria': 'User area header',
    'history.user': 'User',
    'history.email': 'Email',
    'history.btn.newAnalysis': 'New analysis',
    'history.subscription.title': 'My subscription',
    'history.subscription.active': 'ACTIVE',
    'history.subscription.inactive': 'INACTIVE',
    'history.subscription.credits': 'File credits',
    'history.stats.analyses': 'Analyses completed',
    'history.stats.files': 'Files processed',
    'history.stats.lastActivity': 'Last activity',
    'history.loading': 'Loading data...',
    'history.errorPrefix': 'Error',
    'history.unknownError': 'Unknown error',
    'history.notAvailable': 'N/A',
    'history.files.title': 'File history',
    'history.files.empty': 'No history found',
    'history.files.cta': 'Start an analysis',
    'history.files.more': 'Show more ({count} files remaining)',
    // 'history.files.selection.hint': 'Check boxes to select multiple files. Shift + click selects a range.',
    'history.files.selection.count': '{count} file(s) selected',
    'history.files.selection.selectVisible': 'Select visible files',
    'history.files.selection.clearVisible': 'Clear selection',
    'history.files.selection.checkbox': 'Select',
    'history.files.selection.help': 'No file selected',
    'history.files.delete.cta': 'Delete selection',
    'history.files.delete.progress': 'Deleting...',
    'history.files.delete.success': '{count} file(s) deleted.',
    'history.files.delete.partial': '{deleted} deleted. {missing} not found.',
    'history.files.delete.error': 'Unable to delete selected files.',
    'history.files.delete.confirm.one': 'Delete "{name}"? This cannot be undone.',
    'history.files.delete.confirm.many': 'Delete {count} selected files? This cannot be undone.',
    'history.files.name': 'File',
    'history.files.date': 'Date',
    'history.files.type': 'Type',
    'history.files.status': 'Status',
    'history.files.viewReport': 'View report',
    'history.filters.year': 'Year',
    'history.filters.month': 'Month',
    'history.filters.type': 'File type',
    'history.filters.sort': 'Sort',
    'history.filters.all': 'All',
    'history.filters.fec': 'FEC',
    'history.filters.journaux': 'Journals',
    'history.filters.sortDateDesc': 'Date desc',
    'history.filters.sortDateAsc': 'Date asc',
    'history.filters.sortNameAsc': 'Name Aâ†’Z',
    'history.filters.sortNameDesc': 'Name Zâ†’A',
    'history.filters.sortSizeDesc': 'Size desc',
    'history.filters.sortSizeAsc': 'Size asc',
    'history.filters.list': 'List',
    'history.filters.grid': 'Cards',
    'history.status.done': 'Completed',
    'history.status.error': 'Error',
    'history.status.pending': 'Pending',
    'history.status.paid': 'Paid',
    'history.payments.title': 'Payment history',
    'history.payments.empty': 'No payment recorded.',
    'history.payments.item': 'Purchase of {count} files',
    'history.payments.more': 'Show more ({count} payments remaining)',


    // rapport
    'result.1': 'Generated',
    'result.2': 'Period',
    'result.3': 'User',
    'result.4': 'Email',
    'result.5': 'Download',
    'result.6': 'Downloading...',
    'result.7': 'New analysis',
    'result.8': 'Total anomalies',
    'result.9': 'Clear',
    'result.10': 'Loading data...',
    'result.11': 'Analysis summary',
    'result.12': 'Graphical data',
    'result.13': 'Amounts per journal',
    'result.14': 'Monthly evolution',
    'result.15': 'Top 10 accounts',
    'result.16': 'Anomalies / Rows',
    'result.17': 'No anomalies detected',
    'result.18': 'Other rows (partial display)',
    'result.19': 'Unable to load results',
    'result.20': '...',
    'result.21': 'and',
    'result.22': 'others',

    // PDF report
    'pdf.common.yes': 'Yes',
    'pdf.common.no': 'No',
    'pdf.common.na': 'N/A',
    'pdf.common.datePlaceholder': 'dd/mm/yyyy',
    'pdf.document.title': 'FEC Analysis Report',
    'pdf.document.subject': 'FEC Analysis Report',
    'pdf.document.author': 'FECAnalytics',
    'pdf.cover.title': 'Report',
    'pdf.cover.pageLabel': 'Cover',
    'pdf.cover.tag': 'FEC Analysis Report',
    'pdf.cover.period': 'Period',
    'pdf.cover.analysisDate': 'Analysis date',
    'pdf.cover.user': 'User',
    'pdf.cover.exportDate': 'Export date',
    'pdf.reportInfo.title': 'Report Information',
    'pdf.reportInfo.subtitle': 'Generation metadata and analysis context.',
    'pdf.summary.title': 'Analysis Summary',
    'pdf.summary.subtitle': 'Overall summary and summary by section.',
    'pdf.summary.generatedTitle': 'AI Summary',
    'pdf.summary.empty': 'No AI summary available.',
    'pdf.metrics.anomaliesDetected': 'Detected anomalies',
    'pdf.metrics.usefulSubsections': 'Useful subsections',
    'pdf.metrics.status': 'Status',
    'pdf.status.ok': 'OK',
    'pdf.status.watch': 'Needs review',
    'pdf.section.summaryTitle': 'Summary',
    'pdf.section.keyPoints': 'Key points',
    'pdf.section.recurringSignals': 'Recurring signals',
    'pdf.section.examples': 'Examples',
    'pdf.section.empty': 'No actionable item was retained for this section.',
    'pdf.section.noDetailedAnomaly': 'No detailed anomaly',
    'pdf.section.ordinal': 'Section {index}',
    'pdf.section.fallback': 'Section {index}',
    'pdf.section.hiddenChildren': '{count} additional sub-point(s) hidden to preserve a summary format.',
    'pdf.section.hiddenSubsections': '{count} additional subsection(s) not displayed in the PDF.',
    'pdf.subsection.fallback': 'Subsection',
    'pdf.info.userName': 'User name',
    'pdf.info.email': 'Email',
    'pdf.info.userId': 'User identifier',
    'pdf.info.reportReference': 'Report reference',
    'pdf.info.generatedAt': 'Generated date/time',
    'pdf.info.analyzedPeriod': 'Analyzed period',
    'pdf.info.analysisMode': 'Analysis mode',
    'pdf.info.chartPlan': 'Chart of accounts',
    'pdf.params.mode': 'Mode',
    'pdf.params.plan': 'Plan',
    'pdf.params.previousYear': 'N-1',
    'pdf.params.files': 'Files',
    'pdf.sections.Conformite_et_Qualite': 'Compliance And Data Quality',
    'pdf.sections.Coherence_Comptable': 'Accounting Consistency',
    'pdf.sections.Analyse_Financiere_Avancee': 'Advanced Financial Analysis',


    // Simulator
    'simulator.title': 'Withholding tax simulator',
    'simulator.source': 'Source country',
    'simulator.destination': 'Destination country',
    'simulator.amount': 'Amount',
    'simulator.submit': 'Run simulation',
    'simulator.calculating': 'Calculating...',
    'simulator.info': 'Information:',
    'simulator.inputs': 'Inputs:',
    'simulator.rate': 'Applied rate:',
    'simulator.withholding': 'Withholding:',
    'simulator.net': 'Net:',

    // Optimizer
    'optimizer.title': 'Legal optimization generator',
    'optimizer.country': 'Country / Area',
    'optimizer.activity': 'Main activity',
    'optimizer.activity.placeholder': 'e.g., SaaS B2B',
    'optimizer.revenue': 'Annual revenue',
    'optimizer.staff': 'Headcount (employees)',
    'optimizer.submit': 'Generate',
    'optimizer.generating': 'Generating...',
    'optimizer.result.title': 'Result',

    // Generic errors
    'errors.api': 'API call error.',
    'errors.network': 'Network/API error. Please retry.',

    // FAQ
    'faq.title': 'FAQ',
    'faq.subtitle': 'Most common questions about the platform and how it works.',
    'faq.fallback.q1': 'How does the analysis work?',
    'faq.fallback.a1': 'Upload your files and start the analysis. A report is generated automatically.',
    'faq.fallback.q2': 'Are my data secure?',
    'faq.fallback.a2': 'Yes. We only store what is necessary and encrypt communications.',
    'faq.fallback.q3': 'Who can access my data?',
    'faq.fallback.a3': 'Only your account can view your reports. You can request deletion at any time.',
    'faq.fallback.q4': 'Do I need an account to use the platform?',
    'faq.fallback.a4': 'Yes, an account is required to upload files and access simulator features.',
  },
  ar: {
    'nav.home': 'الرئيسية',
    'nav.features': 'المميزات',
    'nav.pricing': 'الأسعار',
    'nav.contact': 'اتصل بنا',
    'nav.demo': 'عرض تجريبي',
    'nav.asavoir': 'معلومات هامة',
    'nav.login': 'تسجيل الدخول',
    'nav.logout': 'تسجيل الخروج',
    'nav.lang': 'العربية',
    'nav.history': 'السجل',
    'nav.dashboard': 'لوحة القيادة',
    'nav.lang.fr': 'Français',
    'nav.lang.en': 'English',
    'nav.lang.ar': 'العربية',
    'nav.documentation': 'التوثيق',

    'msf.langue': 'العربية',
    'msf.title': 'نموذج التحليل',
    'msf.loading': 'يرجى الانتظار',
    'msf.loading.detailed': 'جاري التحليل... قد يستغرق الأمر دقيقة إلى دقيقتين حسب حجم الملف.',
    'msf.loading.stepUpload': 'إرسال الملفات بأمان',
    'msf.loading.stepCheck': 'التحقق من المطابقة',
    'msf.loading.stepAnalysis': 'التحليل والمعالجة',
    'msf.loading.stepReport': 'إنشاء النتائج',
    'msf.draft.resumePrompt': 'هل تريد استئناف آخر مسودة محفوظة؟',
    'msf.steps.import': 'الاستيراد، المعلومات العامة والتحقق من المطابقة',
    'msf.section.importGeneral': 'الاستيراد والمعلومات العامة',
    'msf.section.compliance': 'المطابقة',
    'msf.btn.loadFec': 'تحميل ملف FEC',
    'msf.btn.loadJournals': 'تحميل اليوميات',
    'msf.btn.importPrevFec': 'ملف FEC للعام السابق',
    'msf.btn.clearSelection': 'مسح التحديد',
    'msf.hint.selectOneFile': 'حدد ملفًا واحدًا بالضبط',
    'msf.hint.selectPrevFec': 'ملف FEC للعام السابق (اختياري، لكن يوصى به للتحليلات المقارنة)',
    'msf.hint.upTo10Files': 'حتى 10 ملفات',
    'msf.hint.csvxlsx': '(مقبول CSV/XLSX)',
    'msf.label.chart': 'دليل الحسابات المستخدم',
    'msf.option.select': '-- اختر --',
    'msf.label.openDate': 'تاريخ بداية السنة المالية',
    'msf.label.closeDate': 'تاريخ نهاية السنة المالية',
    'msf.placeholder.date': 'يوم/شهر/سنة',
    'msf.c.label.journal_code': 'رمز اليومية',
    'msf.c.label.journal_label': 'اسم اليومية',
    'msf.c.label.entry_number': 'رقم القيد المحاسبي',
    'msf.c.label.entry_date': 'تاريخ القيد المحاسبي',
    'msf.c.label.account_number': 'رقم الحساب',
    'msf.c.label.account_label': 'اسم الحساب',
    'msf.c.label.entry_label': 'بيان القيد',
    'msf.c.label.document_ref': 'مرجع المستند',
    'msf.c.label.currency': 'عملة المستند',
    'msf.c.label.document_date': 'تاريخ المستند',
    'msf.c.label.debit_amount': 'مبلغ المدين',
    'msf.c.label.credit_amount': 'مبلغ الدائن',
    'msf.c.label.validation_date': 'تاريخ اعتماد القيد',
    'msf.c.placeholder.journal_code': 'رمز_اليومية',
    'msf.c.placeholder.journal_label': 'اسم_اليومية',
    'msf.c.placeholder.entry_number': 'رقم_القيد',
    'msf.c.placeholder.entry_date': 'تاريخ_القيد',
    'msf.c.placeholder.account_number': 'رقم_الحساب',
    'msf.c.placeholder.account_label': 'اسم_الحساب',
    'msf.c.placeholder.entry_label': 'بيان_القيد',
    'msf.c.placeholder.document_ref': 'مرجع_المستند',
    'msf.c.placeholder.currency': 'العملة',
    'msf.c.placeholder.document_date': 'تاريخ_المستند',
    'msf.c.placeholder.debit_amount': 'مبلغ_المدين',
    'msf.c.placeholder.credit_amount': 'مبلغ_الدائن',
    'msf.c.placeholder.validation_date': 'تاريخ_الاعتماد',
    'msf.err.chooseImportMode': 'الرجاء اختيار طريقة استيراد.',
    'msf.err.selectExactlyOneFec': 'حدد ملف FEC واحد فقط.',
    'msf.err.prevFecRequired': 'إذا حددت الخيار، أضف ملف FEC للعام السابق.',
    'msf.err.atLeastOneFile': 'مطلوب ملف واحد على الأقل.',
    'msf.err.maxFiles': 'الحد الأقصى 10 ملفات.',
    'msf.err.required': 'حقل مطلوب',
    'msf.err.closeAfterOpen': 'يجب أن يكون تاريخ الإغلاق بعد تاريخ الفتح.',
    'msf.err.intervalOneYear': 'يجب أن تكون الفترة بين الفتح والإغلاق سنة واحدة (365 إلى 366 يومًا).',
    'msf.err.tooManyKeepFirst10': 'لقد حددت أكثر من 10 ملفات. تم الاحتفاظ بأول 10 فقط.',
    'msf.err.prevFecN1': 'الرجاء تحديد ملف FEC للعام السابق.',
    'msf.err.prefix': 'خطأ:',
    'msf.btn.submit': 'إرسال',
    'msf.btn.cancel': 'إلغاء',

    'payment.title': 'الدفع',
    'payment.selectedPlan': 'الخطة المحددة',
    'payment.connectedAs': 'مسجل الدخول باسم',
    'payment.back': 'رجوع',
    'payment.offer1.badge': 'العرض 1',
    'payment.offer1.title': 'تحليل بسيط بدون ملخص الذكاء الاصطناعي',
    'payment.offer1.desc': 'تحليل بسيط كما هو، بدون ملخص. مثالي لتدقيق سريع.',
    'payment.offer2.badge': 'العرض 2',
    'payment.offer2.title': 'تحليل مع ملخص بالذكاء الاصطناعي',
    'payment.offer2.desc': 'تحليل شامل مصحوب بملخص: النقاط الرئيسية والتوصيات.',
    'payment.offer3.badge': 'العرض 3',
    'payment.offer3.title': 'تحليلات بسيطة قابلة للتخصيص',
    'payment.offer3.desc': 'اختر عدد التحليلات. يعتمد الإجمالي على سعر الوحدة والكمية.',
    'payment.offer4.badge': 'العرض 4',
    'payment.offer4.title': 'تحليلات مخصصة مع ملخص',
    'payment.offer4.desc': 'اختر عدد التحليلات مع الملخص. يعتمد الإجمالي على سعر الوحدة والكمية.',
    'payment.delivery.simple': 'التسليم: تقرير خام (PDF).',
    'payment.delivery.withSummary': 'التسليم: تقرير + ملخص (PDF).',
    'payment.choose': 'اشتراك',
    'payment.proceed': 'اشتراك',
    'payment.field.quantity': 'العدد:',
    'payment.total': 'المجموع:',
    'payment.confirm': 'تأكيد',
    'payment.reset': 'إعادة تعيين',
    'payment.cgv': 'لقد قرأت وقبلت الشروط العامة للبيع',
    'payment.alert.selectedOffer': 'العرض المحدد:',
    'payment.alert.confirmation': 'تأكيد:',
    'payment.status.title': 'حالة الطلب',
    'payment.status.success': 'تم تأكيد الدفع',
    'payment.status.failed': 'فشل الدفع',
    'payment.status.pending': 'الدفع قيد المعالجة',
    'payment.status.unknown': 'حالة الدفع غير معروفة',
    'payment.status.order': 'الطلب',
    'payment.processing': 'جاري التوجيه...',
    'payment.error': 'حدث خطأ أثناء الدفع.',
    'payment.result.title.success': 'تم تأكيد الدفع',
    'payment.result.title.failed': 'فشل الدفع',
    'payment.result.title.pending': 'الدفع قيد الانتظار',
    'payment.result.message.success': 'تم تأكيد طلبك وتحديث رصيدك.',
    'payment.result.message.failed': 'تم رفض الدفع أو إلغاؤه. يمكنك المحاولة مرة أخرى.',
    'payment.result.message.pending': 'جاري تأكيد الدفع. سيتم تحديث هذه الصفحة تلقائياً.',
    'payment.result.refreshHint': 'جاري التحقق...',
    'payment.result.verifyError': 'تعذر التحقق من الطلب.',
    'payment.result.cta.backPayment': 'العودة للدفع',
    'payment.result.cta.home': 'العودة للرئيسية',
    'payment.startAnalysis': 'ابدأ التحليل',
    'payment.success.merci': 'شكرا لشرائك. تمت إضافة رصيدك بنجاح.',

    'remboursement.title': 'طلب استرداد',
    'remboursement.info': 'يرجى ملء هذا النموذج. سيقوم فريقنا بمراجعته خلال 48 ساعة.',
    'remboursement.userNam': 'الاسم الكامل',
    'remboursement.tel': 'الهاتف',
    'remboursement.motif': 'سبب الطلب',
    'remboursement.motif.placeholder': 'اشرح باختصار سبب طلبك...',
    'remboursement.submit': 'إرسال الطلب',
    'remboursement.submit.ing': 'جاري الإرسال...',
    'remboursement.annuler': 'إلغاء',
    'remboursement.notification.succe': 'تم إرسال طلبك بنجاح.',
    'remboursement.notification.error': 'حدث خطأ أثناء إرسال طلبك. يرجى المحاولة لاحقًا.',
    'remboursement.btn.openForm': 'الإبلاغ عن مشكلة أو طلب استرداد',

    'currency.mad': 'درهم',
    'user.default': 'مستخدم',
    'brand.name': 'FECAnalytics',
    'lang.toggle': 'اللغة',

    'login.title': 'تسجيل الدخول',
    'login.register': 'إنشاء حساب',
    'login.login': 'تسجيل الدخول',
    'login.alreadyAccount': 'لديك حساب بالفعل؟ سجل الدخول',
    'login.noAccount': 'ليس لديك حساب؟ إنشاء حساب',
    'login.emailVerification': 'إعادة إرسال بريد التحقق',
    'login.pwdForgot': 'نسيت كلمة المرور؟',
    'login.password': 'كلمة المرور',
    'login.passwordConfirme': 'تأكيد كلمة المرور',
    'login.emailConfireme': 'تأكيد البريد الإلكتروني',
    'login.Chargement': 'جاري التحميل...',
    'login.username': 'اسم المستخدم',
    'login.err': 'يرجى التحقق من معلوماتك، فهي غير صحيحة.',
    'login.success': 'تم التسجيل بنجاح! تم إرسال بريد التحقق إليك.',
    'auth.login_error': 'يرجى التحقق من معلوماتك، فهي غير صحيحة.',

    'footer.title': 'حل مبتكر لإدارة وتحليل ملف القيود المحاسبية، متوافق مع المتطلبات القانونية.',
    'footer.quickLinks': 'روابط سريعة',
    'footer.legal': 'قانوني',
    'footer.mentions': 'إشعار قانوني',
    'footer.privacy': 'سياسة الخصوصية',
    'footer.terms': 'شروط الاستخدام',
    'footer.cgv': 'شروط البيع العامة',
    'footer.guide': 'دليل الاستخدام',
    'footer.copy': 'جميع الحقوق محفوظة.',
    'footer.contact': 'اتصل بنا',
    'footer.contact.emailValue': 'contact@fecanalytics.cloud',
    'footer.contact.phoneValue': '+212 780 38 17 53',
    'footer.contact.addressValue': ' ',
    'footer.contact.link': 'نموذج الاتصال',

    'links.faq': 'الأسئلة الشائعة',
    'links.simulator': 'المحاكي',
    'links.optimizer': 'التحسين',
    'links.home': 'الرئيسية',
    'links.features': 'المميزات',
    'links.about': 'معلومات عنا',
    'links.pricing': 'الأسعار',

    'hero.metaTitle': 'التحليل الذكي لملفات FEC والتدقيق الضريبي الآلي',
    'hero.metaDescription': 'التحليل الذكي لملفات FEC. تأمين المحاسبة الخاصة بك مع FECAnalytics.',
    'hero.titleDefault': 'توقع، تحكم وانجح في تدقيقك الضريبي',
    'hero.subtitleExplicit': 'استعد وتحكم في بياناتك. يمكنك أيضًا إرسال يومياتك المحاسبية للتحليل.',
    'hero.benefit': 'وفر 70% من الوقت في تحليلات FEC الخاصة بك.',
    'hero.cta': 'ابدأ التحليل',
    'hero.demoCta': 'شاهد العرض',

    'services.title': 'المميزات',
    'services.card1.title': 'التحقق من المطابقة الهيكلية',
    'services.card1.desc': 'يهدف هذا الإجراء إلى التحقق من سلامة ودقة واكتمال الملف المحاسبي.',
    'services.card1.alt': 'المطابقة والحماية',
    'services.card2.title': 'الاتساق المحاسبي العام',
    'services.card2.desc': 'تهدف هذه الاختبارات إلى ضمان سلامة واتساق القيود المحاسبية.',
    'services.card2.alt': 'الاتساق المحاسبي',
    'services.card3.title': 'التحليل الضريبي والمحاسبي',
    'services.card3.desc': 'إنشاء تقرير تدقيق مفصل يتتبع الشذوذ المحاسبي المحتمل.',
    'services.card3.alt': 'التحليل والنتائج',
    'services.card4.title': 'اكتشاف متقدم للتشوهات',
    'services.card4.desc': 'خوارزمية ذكاء اصطناعي تحدد الأنماط المشبوهة.',
    'services.card4.alt': 'اكتشاف متقدم',
    'services.card5.title': 'تحسين قانوني',
    'services.card5.desc': 'توصيات مخصصة لتحسين الإدارة المحاسبية والضريبية.',
    'services.card5.alt': 'تحسين',
    'services.card6.title': 'مراقبة ضريبية',
    'services.card6.desc': 'ابق على اطلاع بآخر التطورات التنظيمية والضريبية.',
    'services.card6.alt': 'مراقبة ضريبية',
    'services.card7.title': 'محاكي متعدد السلطات القضائية',
    'services.card7.desc': 'أداة تفاعلية لنمذجة سيناريوهات محاسبية وضريبية مختلفة.',
    'services.card7.alt': 'محاكي متعدد',
    'services.badge.popular': 'الأكثر استخداماً',
    'services.badge.new': 'جديد',
    'services.badge.soon': 'قريباً',

    'asavoir.title': 'معلومات هامة',
    'asavoir.heading': 'الالتزامات القانونية المتعلقة بملف القيود المحاسبية في المغرب',
    'asavoir.p1': 'في المغرب، في إطار التدقيق الضريبي، يتعين على أي شركة تستخدم نظاماً آلياً تقديم نسخة إلكترونية من قيودها المحاسبية.',
    'asavoir.sanctions.title': 'العقوبات في حالة عدم الامتثال',
    'asavoir.sanctions.items': [
      "غرامة قدرها 5000 درهم عن كل سنة مالية لم يتم تقديمها؛",
      "التقييم التلقائي للنتيجة الضريبية؛",
      "تطبيق الغرامات والزيادات."
    ],
    'asavoir.examen.title': 'فحص المحاسبة عن بعد',
    'asavoir.examen.p': 'يمكن للإدارة الضريبية إجراء فحص محاسبي عن بعد باستخدام البيانات الواردة في ملف FEC.',
    'asavoir.proc.p': 'منذ إدخال إجراء فحص المحاسبة، يمكن للإدارة إجراء تدقيق عن بعد. وقت الرد هو 30 يوماً.',
    'asavoir.refs.title': 'مراجع مفيدة',
    'asavoir.refs.items': [
      'المدونة العامة للضرائب؛',
      'قرار 25 يناير 2016؛',
      'تعميمات الإدارة العامة للضرائب.'
    ],

    'demo.aria': 'العرض التوضيحي',
    'demo.title': 'عرض تجريبي',
    'demo.play': 'تشغيل الفيديو',
    'demo.offer.badge1': 'عرض',
    'demo.offer.badge2': 'مدفوع',
    'demo.desc': 'قم باستيراد يومياتك أو ملفات FEC واحصل على:',
    'demo.b1': 'تحليل كامل وآلي',
    'demo.b2': 'تقرير مفصل واحترافي',
    'demo.b3': 'تنزيل فوري لنتائجك',
    'demo.cta': 'ابدأ التحليل',

    'pricing.offer': 'العرض',
    'pricing.priceLine': 'دفع لمرة واحدة لكل ملف تم تحليله',
    'pricing.cta': 'ابدأ التحليل',

    'stats.analyzed': 'الملفات المحللة',
    'stats.users': 'المستخدمين',
    'stats.files': 'الملفات',
    'stats.subscriptions': 'الاشتراكات',
    'stats.clients': 'عملاء راضون',
    'stats.countries': 'البلدان المخدومة',
    'stats.satisfaction': 'معدل الرضا',

    'contact.title': 'معلوماتك',
    'contact.civ': 'اللقب',
    'contact.civ.choose': 'اختر...',
    'contact.civ.mr': 'السيد',
    'contact.civ.ms': 'السيدة',
    'contact.firstname': 'الاسم الأول',
    'contact.lastname': 'الاسم الأخير',
    'contact.email': 'البريد الإلكتروني',
    'contact.email.placeholder': 'عنوان البريد',
    'contact.phone': 'الهاتف المحمول',
    'contact.phone.placeholder': 'الهاتف المحمول',
    'contact.phone.title': 'رقم هاتف صحيح',
    'contact.address': 'العنوان',
    'contact.address.placeholder': 'رقم واسم الشارع',
    'contact.postcode': 'الرمز البريدي',
    'contact.postcode.placeholder': 'الرمز البريدي',
    'contact.country': 'البلد',
    'contact.country.choose': 'اختر بلداً...',
    'contact.city': 'المدينة',
    'contact.city.placeholder': 'المدينة',
    'contact.message': 'الرسالة',
    'contact.message.placeholder': 'رسالتك...',
    'contact.send': 'إرسال',
    'contact.sending': 'جاري الإرسال...',
    'contact.alert.missing': 'يرجى إدخال الاسم الأول والأخير والبريد الإلكتروني على الأقل.',
    'contact.alert.serverPrefix': 'خطأ في الخادم: ',
    'contact.alert.unable': 'تعذر حفظ معلوماتك. تحقق من الخادم وحاول مرة أخرى.',
    'contact.alert.thanks': 'شكراً! تم حفظ معلوماتك.',

    'history.title': 'مساحتي',
    'history.header.aria': 'رأس مساحة المستخدم',
    'history.user': 'المستخدم',
    'history.email': 'البريد الإلكتروني',
    'history.btn.newAnalysis': 'تحليل جديد',
    'history.subscription.title': 'اشتراكي',
    'history.subscription.active': 'نشط',
    'history.subscription.inactive': 'غير نشط',
    'history.subscription.credits': 'رصيد الملفات',
    'history.stats.analyses': 'التحليلات المنجزة',
    'history.stats.files': 'الملفات المعالجة',
    'history.stats.lastActivity': 'آخر نشاط',
    'history.loading': 'جاري تحميل البيانات...',
    'history.errorPrefix': 'خطأ',
    'history.unknownError': 'خطأ غير معروف',
    'history.notAvailable': 'غير متوفر',
    'history.files.title': 'سجل الملفات',
    'history.files.empty': 'لا يوجد سجل',
    'history.files.cta': 'بدء تحليل',
    'history.files.more': 'عرض المزيد ({count} ملفات متبقية)',
    'history.files.selection.count': 'تم تحديد {count} ملف(ات)',
    'history.files.selection.selectVisible': 'تحديد القائمة المعروضة',
    'history.files.selection.clearVisible': 'إلغاء تحديد الكل',
    'history.files.selection.checkbox': 'تحديد',
    'history.files.selection.help': 'لم يتم تحديد أي ملف',
    'history.files.delete.cta': 'حذف التحديد',
    'history.files.delete.progress': 'جاري الحذف...',
    'history.files.delete.success': 'تم حذف {count} ملف(ات).',
    'history.files.delete.partial': 'تم حذف {deleted}. تعذر العثور على {missing}.',
    'history.files.delete.error': 'تعذر حذف التحديد.',
    'history.files.delete.confirm.one': 'حذف "{name}"؟ هذا الإجراء نهائي.',
    'history.files.delete.confirm.many': 'حذف {count} ملفات محددة؟ هذا الإجراء نهائي.',
    'history.files.name': 'الملف',
    'history.files.date': 'التاريخ',
    'history.files.type': 'النوع',
    'history.files.status': 'الحالة',
    'history.files.viewReport': 'عرض التقرير',
    'history.filters.year': 'السنة',
    'history.filters.month': 'الشهر',
    'history.filters.type': 'نوع الملف',
    'history.filters.sort': 'فرز',
    'history.filters.all': 'الكل',
    'history.filters.fec': 'FEC',
    'history.filters.journaux': 'يوميات',
    'history.filters.sortDateDesc': 'التاريخ تنازلي',
    'history.filters.sortDateAsc': 'التاريخ تصاعدي',
    'history.filters.sortNameAsc': 'الاسم من أ إلى ي',
    'history.filters.sortNameDesc': 'الاسم من ي إلى أ',
    'history.filters.sortSizeDesc': 'الحجم تنازلي',
    'history.filters.sortSizeAsc': 'الحجم تصاعدي',
    'history.filters.list': 'قائمة',
    'history.filters.grid': 'بطاقات',
    'history.status.done': 'مكتمل',
    'history.status.error': 'خطأ',
    'history.status.pending': 'قيد الانتظار',
    'history.status.paid': 'مدفوع',
    'history.payments.title': 'سجل المدفوعات',
    'history.payments.empty': 'لا يوجد دفع مسجل.',
    'history.payments.item': 'شراء {count} ملفات',
    'history.payments.more': 'عرض المزيد ({count} مدفوعات متبقية)',

    'simulator.title': 'محاكي الاقتطاع من المنبع',
    'simulator.source': 'بلد المصدر',
    'simulator.destination': 'بلد الوجهة',
    'simulator.amount': 'المبلغ',
    'simulator.submit': 'بدء المحاكاة',
    'simulator.calculating': 'جاري الحساب...',
    'simulator.info': 'معلومات:',
    'simulator.inputs': 'المدخلات:',
    'simulator.rate': 'النسبة المطبقة:',
    'simulator.withholding': 'الاقتطاع:',
    'simulator.net': 'الصافي:',

    'result.1': 'تم الإنشاء',
    'result.2': 'الفترة',
    'result.3': 'المستخدم',
    'result.4': 'البريد',
    'result.5': 'تحميل',
    'result.6': 'جاري التحميل...',
    'result.7': 'تحليل جديد',
    'result.8': 'إجمالي التشوهات',
    'result.9': 'مسح',
    'result.10': 'جاري تحميل البيانات...',
    'result.11': 'ملخص التحليل',
    'result.12': 'بيانات رسومية',
    'result.13': 'المبالغ لكل يومية',
    'result.14': 'التطور الشهري',
    'result.15': 'أفضل 10 حسابات',
    'result.16': 'التشوهات / الأسطر',
    'result.17': 'لم يتم اكتشاف تشوهات',
    'result.18': 'أسطر أخرى',
    'result.19': 'تعذر تحميل النتائج',
    'result.20': '...',
    'result.21': 'و',
    'result.22': 'آخرون',

    'pdf.common.yes': 'نعم',
    'pdf.common.no': 'لا',
    'pdf.common.na': 'غير متوفر',
    'pdf.common.datePlaceholder': 'يوم/شهر/سنة',
    'pdf.document.title': 'تقرير تحليل FEC',
    'pdf.document.subject': 'تقرير تحليل FEC',
    'pdf.document.author': 'FECAnalytics',
    'pdf.cover.title': 'تقرير',
    'pdf.cover.pageLabel': 'غلاف',
    'pdf.cover.tag': 'تقرير تحليل FEC',
    'pdf.cover.period': 'الفترة',
    'pdf.cover.analysisDate': 'تاريخ التحليل',
    'pdf.cover.user': 'المستخدم',
    'pdf.cover.exportDate': 'تاريخ التصدير',
    'pdf.reportInfo.title': 'معلومات التقرير',
    'pdf.reportInfo.subtitle': 'البيانات الوصفية وسياق التحليل.',
    'pdf.summary.title': 'ملخص التحليل',
    'pdf.summary.subtitle': 'ملخص عام وملخص حسب القسم.',
    'pdf.summary.generatedTitle': 'ملخص الذكاء الاصطناعي',
    'pdf.summary.empty': 'لا يوجد ملخص متاح.',
    'pdf.metrics.anomaliesDetected': 'التشوهات المكتشفة',
    'pdf.metrics.usefulSubsections': 'الأقسام الفرعية المفيدة',
    'pdf.metrics.status': 'الحالة',
    'pdf.status.ok': 'جيد',
    'pdf.status.watch': 'للمراقبة',
    'pdf.section.summaryTitle': 'ملخص',
    'pdf.section.keyPoints': 'النقاط الرئيسية',
    'pdf.section.recurringSignals': 'إشارات متكررة',
    'pdf.section.examples': 'أمثلة',
    'pdf.section.empty': 'لم يتم الاحتفاظ بأي عنصر قابل للاستخدام.',
    'pdf.section.noDetailedAnomaly': 'لا يوجد شذوذ مفصل',
    'pdf.section.ordinal': 'القسم {index}',
    'pdf.section.fallback': 'القسم {index}',
    'pdf.section.hiddenChildren': 'تم إخفاء {count} نقاط فرعية.',
    'pdf.section.hiddenSubsections': 'تم إخفاء {count} أقسام فرعية.',
    'pdf.subsection.fallback': 'قسم فرعي',
    'pdf.info.userName': 'اسم المستخدم',
    'pdf.info.email': 'البريد',
    'pdf.info.userId': 'معرف المستخدم',
    'pdf.info.reportReference': 'مرجع التقرير',
    'pdf.info.generatedAt': 'تاريخ الإنشاء',
    'pdf.info.analyzedPeriod': 'الفترة المحللة',
    'pdf.info.analysisMode': 'وضع التحليل',
    'pdf.info.chartPlan': 'دليل الحسابات',
    'pdf.params.mode': 'الوضع',
    'pdf.params.plan': 'الدليل',
    'pdf.params.previousYear': 'السنة السابقة',
    'pdf.params.files': 'الملفات',
    'pdf.sections.Conformite_et_Qualite': 'المطابقة وجودة البيانات',
    'pdf.sections.Coherence_Comptable': 'الاتساق المحاسبي',
    'pdf.sections.Analyse_Financiere_Avancee': 'التحليل المالي المتقدم',

    'optimizer.title': 'مولد التحسين القانوني',
    'optimizer.country': 'البلد / المنطقة',
    'optimizer.activity': 'النشط الرئيسي',
    'optimizer.activity.placeholder': 'مثال: SaaS B2B',
    'optimizer.revenue': 'الإيرادات السنوية',
    'optimizer.staff': 'عدد الموظفين',
    'optimizer.submit': 'إنشاء',
    'optimizer.generating': 'جاري الإنشاء...',
    'optimizer.result.title': 'النتيجة',

    'errors.api': 'خطأ في استدعاء API.',
    'errors.network': 'خطأ في الشبكة. أعد المحاولة.',

    'doc.meta.title': 'التوثيق - دليل الاستخدام',
    'doc.meta.desc': 'الدليل الرسمي لاستخدام المنصة.',
    'doc.hero.title': 'توثيق FECAnalytics',
    'doc.hero.subtitle': 'دليل المستخدم الرسمي.',
    'doc.hero.start': 'ابدأ التحليل',
    'doc.hero.login': 'تسجيل الدخول',
    'doc.intro.title': 'نظرة عامة',
    'doc.intro.desc': 'الحل المبتكر الذي يتيح لك:',
    'doc.intro.item1': 'تحليل ملفات اليوميات.',
    'doc.intro.item2': 'اكتشاف التشوهات.',
    'doc.intro.item3': 'توقع التدقيق.',
    'doc.intro.item4': 'أتمتة التحقق.',
    'doc.step1.title': '1. إنشاء حساب',
    'doc.step1.desc': 'يجب إنشاء حساب للوصول للوحة القيادة.',
    'doc.step2.title': '2. شراء الرصيد',
    'doc.step2.desc': 'تكلفة التحليل 1000 درهم.',
    'doc.step2.note': '1 رصيد = 1 تحليل = 1 سنة',
    'doc.step3.title': '3. تحميل الملفات',
    'doc.step3.desc': 'يجب تحميل الملف بصيغة مناسبة.',
    'doc.step4.title': '4. دليل الحسابات',
    'doc.step4.desc': 'المنصة تدعم دليل الحسابات المغربي حالياً.',
    'doc.step4.note': 'سيتم إضافة أدلة أخرى قريباً.',
    'doc.step5.title': '5. مطابقة الأعمدة',
    'doc.step5.desc': 'قم بمطابقة أعمدة ملفك بالمنصة.',
    'doc.step5.field1': 'رمز اليومية',
    'doc.step5.field2': 'التاريخ',
    'doc.step5.field3': 'الحساب',
    'doc.step5.field4': 'البيان',
    'doc.step5.field5': 'مدين',
    'doc.step5.field6': 'دائن',
    'doc.step5.footer': 'تضمن هذه الخطوة دقة التحليل.',
    'doc.launch.title': 'بدء التحليل',
    'doc.launch.desc': 'انقر على إرسال وسيبدأ التحليل فوراً.',
    'doc.report.title': 'التقرير النهائي',
    'doc.report.desc': 'يمكنك تنزيل التقرير بصيغة PDF.',
    'doc.history.title': 'السجل والنسخ الاحتياطي',
    'doc.history.desc': 'السجل يخضع لمعايير صارمة:',
    'doc.history.item1': 'التقرير متاح حتى يتم إجراء تحليل جديد.',
    'doc.history.item2': 'يحل التحليل الجديد محل القديم.',
    'doc.history.item3': 'يوصى بتنزيل التقرير فوراً.',
    'doc.faq.title': 'أسئلة شائعة',
    'doc.faq.q1': 'ما هي الملفات المدعومة؟',
    'doc.faq.a1': 'ندعم CSV و XLSX و TXT.',
    'doc.faq.q2': 'كم يكلف التحليل؟',
    'doc.faq.a2': '1000 درهم للتحليل.',
    'doc.faq.q3': 'ما هي مدة التحليل؟',
    'doc.faq.a3': 'يغطي التحليل فترة محاسبية تصل لعام.',
    'doc.faq.q4': 'هل يمكنني استرداد تقرير قديم؟',
    'doc.faq.a4': 'نعم، ما لم تبدأ تحليلاً جديداً.',
    'doc.faq.q5': 'ما هي الأدلة المدعومة؟',
    'doc.faq.a5': 'حالياً الدليل المغربي فقط.',
    'doc.faq.q6': 'كم يستغرق التحليل؟',
    'doc.faq.a6': 'بضع دقائق فقط.',
    'doc.cta.title': 'هل أنت مستعد؟',
    'doc.cta.desc': 'انضم إلى المحترفين واستخدم الذكاء الاصطناعي.',
    'doc.cta.btn1': 'ابدأ الآن',
    'doc.cta.btn2': 'إنشاء حساب',

    'faq.title': 'الأسئلة الشائعة',
    'faq.subtitle': 'الأسئلة الأكثر طرحًا حول المنصة.',
    'faq.fallback.q1': 'كيف يعمل التحليل؟',
    'faq.fallback.a1': 'حمل ملفاتك وابدأ التحليل.',
    'faq.fallback.q2': 'هل بياناتي آمنة؟',
    'faq.fallback.a2': 'نعم، نحن نقوم بتشفير البيانات.',
    'faq.fallback.q3': 'من يمكنه الوصول لبياناتي؟',
    'faq.fallback.a3': 'حسابك فقط هو من يمكنه الوصول.',
    'faq.fallback.q4': 'هل أحتاج لحساب؟',
    'faq.fallback.a4': 'نعم، الحساب مطلوب لاستخدام المنصة.',
  }
};

export const fallbackLang = 'fr';
